import Menu from './Compartido/Menu.jsx';
import TextosPreautorizar from './Preautorizar/TextosPreautorizar.jsx';
import Footer from './Compartido/Footer.jsx';

const Preautorizar = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <TextosPreautorizar
                datoscliente={props.datoscliente}
                datospropiedad={props.datospropiedad}
                reserva={props.reserva}
                fianza={props.fianza}
                config={props.config}
                tpvs={props.tpvs}
                lang={props.lang}
                ruta={props.ruta}
                moneda={props.moneda}
                params={props.params}
                version={props.version}
                signature={props.signature}
                urlpago={props.urlpago}
                colorboton={props.colorboton}
            />
            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    );
}
export default Preautorizar;
